import type { CountryLanguages } from '~/types/countryLanguages';
import type { StoryblokConfigSlug } from '~/types/storyblokConfigSlug';
import { findSectionConfigForPath } from '~/utils/findSectionConfigForPath';
import { parseLocaleFromPath } from '~/utils/parseLocaleFromPath';
import { resolveSectionPath } from '~/utils/resolveSectionPath';

export function isValidAccountSectionPath(
    registry: StoryblokConfigSlug[] | null | undefined,
    path: string,
    countryLanguages: CountryLanguages
): boolean {
    const segments = path.split('/').filter(Boolean);
    const accountIndex = segments.indexOf('account');
    const requestedSectionPath = accountIndex > 1 ? segments.slice(1, accountIndex).join('/') : '';
    if (!requestedSectionPath) return true;

    const locale = parseLocaleFromPath(path);
    const sectionConfig = findSectionConfigForPath(registry, path, countryLanguages);
    if (!locale?.language || !sectionConfig || sectionConfig.sectionId === 'root') return false;

    return resolveSectionPath(sectionConfig, locale.language, countryLanguages) === requestedSectionPath;
}
